import axios from "axios";
import jwtDecode from "jwt-decode";
import { HOST_API } from "../config";
//
import axiosInstance from "./axios";

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  // ----------------------------------------------------------------------

  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

const getTokenExp = (accessToken) => {
  if (!accessToken) return null;
  try {
    return jwtDecode(accessToken).exp;
  } catch {
    return null;
  }
};

const isRememberMe = () => {
  try {
    return localStorage.getItem("rememberMe") === "1";
  } catch {
    return false;
  }
};

// Refresh against the backend using a bare axios call (no instance interceptor
// → avoids infinite 401 loops). Returns the new access_token or null.
let refreshInFlight = null;
const refreshAccessToken = async () => {
  if (refreshInFlight) return refreshInFlight;
  const current = localStorage.getItem("accessToken");
  if (!current) return null;
  refreshInFlight = (async () => {
    try {
      const URL = `${HOST_API}api/refresh`;
      const { status, data } = await axios.post(URL, null, {
        headers: { Authorization: `Bearer ${current}` },
      });
      if (status === 200 && data?.access_token) {
        setSession(data.access_token);
        return data.access_token;
      }
      return null;
    } catch (_err) {
      return null;
    } finally {
      refreshInFlight = null;
    }
  })();
  return refreshInFlight;
};

// ----------------------------------------------------------------------

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    if (axiosInstance && axiosInstance.defaults) {
      axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    }
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
    if (axiosInstance && axiosInstance.defaults) {
      delete axiosInstance.defaults.headers.common.Authorization;
    }
  }
};

export { getTokenExp, isRememberMe, isValidToken, refreshAccessToken, setSession };
